import { render } from "./tipshints.vue?vue&type=template&id=b5d27c56&scoped=true"
import script from "./tipshints.vue?vue&type=script&lang=js"
export * from "./tipshints.vue?vue&type=script&lang=js"

import "./tipshints.vue?vue&type=style&index=0&id=b5d27c56&scoped=true&lang=less"

import exportComponent from "D:\\Septris Remake\\septris-remake\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d27c56"]])

export default __exports__